var tagColors = ['greenLight', 'tealLight', 'blueLight', 'purpleLight', 'redLight', 'yellowLight'];
var getHash = function getHash(str) {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    // tslint:disable:no-bitwise
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash = hash & hash;
    // tslint:enable:no-bitwise
  }
  return hash;
};
export var getTagColor = function getTagColor() {
  var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return tagColors[Math.abs(getHash(tagName)) % tagColors.length];
};